<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M11.625 12.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-5.25 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"/>
    <path d="M5.258 6.75h7.5v3.75h-7.5V6.75ZM13.35 2.1C12 1.567 10.395 1.5 9 1.5c-1.395 0-3 .067-4.35.6-2.003.78-3.15 2.437-3.15 4.545V16.5h15V6.645c0-2.107-1.148-3.765-3.15-4.545Zm.15 9.81a1.969 1.969 0 0 1-1.973 1.965l.848.84V15H11.25l-1.125-1.125H8.002L6.877 15H5.626v-.285l.84-.84A1.972 1.972 0 0 1 4.5 11.91V6.75C4.5 4.777 6.75 4.5 9 4.5c2.49 0 4.5.285 4.5 2.25v5.16Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
